import axiosInstance from "@/api/axios-instance";
import {
  ConsentFormStatus,
  DuplicateIdentifierGroup,
} from "@/pages/users/types/user";

export async function getDuplicateIdentifiers(params: {
  search?: string;
  is_lead?: boolean;
  product_id?: string;
  hrc_status?: ConsentFormStatus;
  mc_status?: ConsentFormStatus;
}): Promise<{ groups: DuplicateIdentifierGroup[] }> {
  const response = await axiosInstance.get("/users/duplicate-identifiers", {
    params,
  });
  return response.data;
}
